import { render, staticRenderFns } from "./commenthead.vue?vue&type=template&id=51acf967&scoped=true"
import script from "./commenthead.vue?vue&type=script&lang=js"
export * from "./commenthead.vue?vue&type=script&lang=js"
import style0 from "./commenthead.vue?vue&type=style&index=0&id=51acf967&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51acf967",
  null
  
)

export default component.exports